import { mergeObjectTypes } from '../cacheHelpers';

const RoadTrackedShipment = {
  keyFields: ['zencargoReference'],
  merge: mergeObjectTypes
};

export default RoadTrackedShipment;
